<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Transporter</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        @click="showAddForm = true; form = { transporter_code: '', name: '', address_1: '', address_2: '', area_id: null, pic: '', phone: '', email: '' }"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        @click="viewData"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeData"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="showFilterForm = true"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        </vx-card>
        <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
            <div class="con-exemple-prompt">
                <vs-input
                    v-model="filter.transporter_code"
                    id="pan"
                    class="mb-2 w-full wr_input"
                    label="Transporter ID"
                />
                <vs-input v-model="filter.name" class="mb-2 w-full" label="Name" />
                <vs-input v-model="filter.address_1" class="mb-2 w-full" label="Address 1" />
                <vs-input v-model="filter.address_2" class="mb-2 w-full" label="Address 2" />
                <label class="pl-2">Area</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.area_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, area)"
                >
                    <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>
                <vs-input v-model="filter.pic" class="mb-2 w-full" label="PIC" />
                <vs-input
                    v-model="filter.phone"
                    class="mb-2 w-full"
                    label="Phone"
                    @keypress="isNumber($event)"
                    maxlength="13"
                />
                <vs-input v-model="filter.email" class="mb-2 w-full" label="Email" />
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                    <vs-button color="primary" class="mt-2" @click="filterData">Search</vs-button>
                </vs-row>
            </div>
        </vs-prompt>

        <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
            <div class="con-exemple-prompt">
                <vs-input
                    v-model="form.transporter_code"
                    id="pan"
                    class="mb-2 w-full wr_input"
                    label="Transporter ID"
                    :disabled="!editMode"
                />
                <vs-input
                    v-model="form.name"
                    class="mb-2 w-full"
                    label="Name"
                    :disabled="!editMode"
                />
                <vs-input
                    v-model="form.address_1"
                    class="mb-2 w-full"
                    label="Address 1"
                    :disabled="!editMode"
                />
                <vs-input
                    v-model="form.address_2"
                    class="mb-2 w-full"
                    label="Address 1"
                    :disabled="!editMode"
                />
                <label class="pl-2">Area</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="form.area_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, area)"
                    :disabled="!editMode"
                >
                    <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>
                <vs-input v-model="form.pic" class="mb-2 w-full" label="PIC" :disabled="!editMode" />
                <vs-input
                    v-model="form.phone"
                    class="mb-2 w-full"
                    label="Phone"
                    @keypress="isNumber($event)"
                    maxlength="13"
                    :disabled="!editMode"
                />
                <vs-input
                    v-model="form.email"
                    class="mb-2 w-full"
                    label="Email"
                    :disabled="!editMode"
                />
                <vs-select
                    class="selectExample mb-2 w-full"
                    v-model="form.requires_awb"
                    label="Requires AWB"
                    :disabled="!editMode"
                >
                    <vs-select-item value="1" text="Yes"/>
                    <vs-select-item value="0" text="No"/>
                </vs-select>
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                    <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
                    <vs-button
                        color="primary"
                        class="mt-2"
                        @click="saveData"
                        :disabled="!editMode"
                    >Save</vs-button>
                </vs-row>
            </div>
        </vs-prompt>

        <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
            <div class="con-exemple-prompt">
                <vs-input
                    v-model="form.transporter_code"
                    id="pan"
                    class="mb-2 w-full wr_input"
                    label="Transporter ID"
                />
                <vs-input v-model="form.name" class="mb-2 w-full" label="Name" />
                <vs-input v-model="form.address_1" class="mb-2 w-full" label="Address 1" />
                <vs-input v-model="form.address_2" class="mb-2 w-full" label="Address 2" />
                <label class="pl-2">Area</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="form.area_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, area)"
                >
                    <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>
                <vs-input v-model="form.pic" class="mb-2 w-full" label="PIC" />
                <vs-input
                    v-model="form.phone"
                    class="mb-2 w-full"
                    label="Phone"
                    @keypress="isNumber($event)"
                    maxlength="13"
                />
                <vs-input v-model="form.email" class="mb-2 w-full" label="Email" />
                <vs-select
                    class="selectExample mb-2 w-full"
                    v-model="form.requires_awb"
                    label="Requires AWB"
                >
                    <vs-select-item value="1" text="Yes"/>
                    <vs-select-item value="0" text="No"/>
                </vs-select>
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                    <vs-button color="primary" class="mt-2" @click="addData">Save</vs-button>
                </vs-row>
            </div>
        </vs-prompt>
        <!-- Add Area -->
        <vs-popup title="Area" :active.sync="addarea.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="addarea.search" placeholder="Area" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handleaddareasearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="addarea.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="addarea.columnDefs"
                :defaultColDef="addarea.defaultColDef"
                :rowData="addarea.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickaddarea"
                @selection-changed="onchangeselectionaddarea"
            ></ag-grid-vue>
        </vs-popup>
        <!-- View Area -->
        <vs-popup title="Area" :active.sync="viewarea.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="viewarea.search" placeholder="Area" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handleviewareasearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="viewarea.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="viewarea.columnDefs"
                :defaultColDef="viewarea.defaultColDef"
                :rowData="viewarea.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickviewarea"
                @selection-changed="onchangeselectionviewarea"
            ></ag-grid-vue>
        </vs-popup>
        <!-- Filter Area -->
        <vs-popup title="Area" :active.sync="filterarea.show" style="z-index: 99999">
            <vx-input-group>
                <vs-input v-model="filterarea.search" placeholder="Area" />
                <template slot="append">
                    <div class="append-text btn-addon">
                        <vs-button
                            size="small"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-search"
                            @click="handlefilterareasearch"
                        ></vs-button>
                    </div>
                </template>
            </vx-input-group>
            <ag-grid-vue
                :gridOptions="filterarea.gridoptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="filterarea.columnDefs"
                :defaultColDef="filterarea.defaultColDef"
                :rowData="filterarea.rowdata"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @rowDoubleClicked="rowdoubleclickfilterarea"
                @selection-changed="onchangeselectionfilterarea"
            ></ag-grid-vue>
        </vs-popup>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            editMode: false,
            filter: {
                transporter_code: "",
                name: "",
                address_1: "",
                address_2: "",
                area_id: null,
                pic: "",
                phone: "",
                email: ""
            },
            form: {
                transporter_code: "",
                name: "",
                address_1: "",
                address_2: "",
                area_id: null,
                pic: "",
                phone: "",
                email: "",
                requires_awb:null
            },
            area: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'village'
            },
            addarea: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            viewarea: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },
            filterarea: {
                show: false,
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                search: "",
                select: {}
            },

            // Show forms
            showFilterForm: false,
            showViewForm: false,
            showAddForm: false,

            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        saveData() {
            this.isLoading = true;
            this.$http
                .put(
                    "master/transporters/" + this.selectedId + "/update",
                    this.form
                )
                .then(() => {
                    this.isLoading = false;
                    this.form = {
                        transporter_code: "",
                        name: "",
                        address_1: "",
                        address_2: "",
                        area_id: null,
                        pic: "",
                        phone: "",
                        email: ""
                    };
                    this.editMode = false;
                    this.showViewForm = false;
                    this.selectedId = null;
                    this.$vs.notify({
                        color: "success",
                        title: "Data Updated",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected data was successfully Updated"
                    });
                    this.fetchData();
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.notify({
                        title: "Error",
                        text: "Something went wrong",
                        color: "danger"
                    });
                });
        },
        addData() {
            this.isLoading = true;
            this.$http
                .post("master/transporters/store", this.form)
                .then(() => {
                    this.isLoading = false;
                    this.showAddForm = false;
                    this.$vs.notify({
                        color: "success",
                        title: "Data Added",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected data was successfully Added"
                    });
                    this.fetchData();
                })
                .catch(e => this.handleError(e))
        },
        removeData() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this data?",
                accept: () => {
                    this.isLoading = true;
                    this.$http
                        .delete(
                            "master/transporters/" +
                                this.selectedId +
                                "/destroy"
                        )
                        .then(res => {
                            this.$vs.notify({
                                color: "success",
                                title: "Data deleted",
                                iconPack: "feather",
                                icon: "icon-check",
                                text:
                                    "The selected data was successfully deleted"
                            });
                            this.selectedId = null;
                            this.fetchData();
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.$vs.notify({
                                title: "Error",
                                text: "Something went wrong",
                                color: "danger"
                            });
                        });
                }
            });
        },
        // Pop UP
        handleaddareapopup() {
            this.addarea.show = true;
            this.viewarea.gridoptions.api.sizeColumnsToFit();
            this.getAddArea();
        },
        handleviewareapopup() {
            this.viewarea.show = true;
            this.viewarea.gridoptions.api.sizeColumnsToFit();
            this.getViewArea();
        },
        handlefilterareapopup() {
            this.filterarea.show = true;
            this.filterarea.gridoptions.api.sizeColumnsToFit();
            this.getFilterArea();
        },
        // On Selection Area
        onchangeselectionaddarea() {
            let selectedRows = this.addarea.gridoptions.api.getSelectedRows();
            this.addarea.select = selectedRows[0];
        },
        onchangeselectionviewarea() {
            let selectedRows = this.viewarea.gridoptions.api.getSelectedRows();
            this.viewarea.select = selectedRows[0];
        },
        onchangeselectionfilterarea() {
            let selectedRows = this.filterarea.gridoptions.api.getSelectedRows();
            this.filterarea.select = selectedRows[0];
        },
        // Row Double Click
        rowdoubleclickaddarea() {
            this.addarea.show = false;
            this.form.area_id = this.addarea.select.village;
        },
        rowdoubleclickviewarea() {
            this.viewarea.show = false;
            this.form.area_id = this.viewarea.select.village;
        },
        rowdoubleclickfilterarea() {
            this.filterarea.show = false;
            this.filter.area_id = this.filterarea.select.village;
        },
        // Search
        handleaddareasearch() {
            this.getAddArea();
        },
        handleviewareasearch() {
            this.getViewArea();
        },
        handlefilterareasearch() {
            this.getFilterArea();
        },
        // Get Api
        getAddArea() {
            this.isLoading = true;
            this.$http
                .post("master/areas", {
                    village: this.addarea.search
                })
                .then(res => {
                    this.addarea.rowdata = res.data.data;
                })
                .catch(error => this.handleError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
        getViewArea() {
            this.isLoading = true;
            this.$http
                .post("master/areas", {
                    village: this.viewarea.search
                })
                .then(res => {
                    this.viewarea.rowdata = res.data.data;
                })
                .catch(error => this.handleError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
        getFilterArea() {
            this.isLoading = true;
            this.$http
                .post("master/areas", {
                    village: this.filterarea.search
                })
                .then(res => {
                    this.filterarea.rowdata = res.data.data;
                })
                .catch(error => this.handleError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
        refreshData() {
            this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
        },
        fetchData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            Promise.all([
                this.$http.post(
                    "master/transporters?page=" + this.currentPage,
                    this.filter
                )
            ])
                .then(
                    this.$http.spread((transporters, areas) => {
                        this.data = transporters.data.data;
                        this.totalPage = transporters.data.last_page;
                        this.currentPage = this.currentPage;
                        this.dataTotal = transporters.data.total;
                        this.dataFrom = transporters.data.from;
                        this.dataTo = transporters.data.to;
                        this.isLoading = false;
                    })
                )
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                    return;
                });
            // .catch(() => {
            //   this.$vs.dialog({
            //     type: "confirm",
            //     color: "danger",
            //     title: "Error",
            //     text: "Try again?",
            //     accept: () => {
            //       this.refreshData();
            //     },
            //     acceptText: "Yes",
            //     cancelText: "No"
            //   });
            // })
            // .then(() => (this.isLoading = false));
        },
        viewData() {
            this.isLoading = true;
            this.$http
                .get("master/transporters/" + this.selectedId)
                .then(res => {
                    this.editMode = false
                    this.form = res.data;
                    if(this.area.data.findIndex(a => a.id == res.data.area_id) === -1) {
                        this.area.data.push({
                            id: res.data.area_id,
                            village: res.data.area
                        })
                    }
                    this.showViewForm = true
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        filterData() {
            this.currentPage = 1;
            this.showFilterForm = false;
            this.fetchData();
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/transporters/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "Transporters-template.xlsx");
                });
        },
        uploadExcel(e) {
            let file = e.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/transporters/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    setTimeout(() => {
                        this.$vs.notify({
                            color: "success",
                            title: "Upload Success",
                            text: "Upload Data Transporters Successfully"
                        });
                    }, 500);
                })
                .catch(error => this.handleError(error))
        },
        exportExcel() {
            this.isLoading = true;
            this.$http
                .post("master/transporters/report/exportexcel", this.filter, {
                    responseType: "blob"
                })
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    this.isLoading = false;
                    saveAs(blob, "Transporters-list-export.xlsx");
                });
        },
        fetchDropdown() {
            this.isLoading = true
            return Promise.all([
                this.$http.post(
                "master/areas",
                ),
            ]).then(
                this.$http.spread((areas) => {
                    areas.data.data.map(area => {
                        if(this.area.data.findIndex(a => a.id == area.id) === -1) {
                            this.area.data.push(area)
                        }
                    })
                })
            )
        },
    },
    mounted() {
        this.fetchDropdown().then(() => this.fetchData())
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Transporter ID",
                field: "transporter_code",
                width: 120,
            },
            {
                headerName: "Name",
                field: "name",
                width: 120,
            },
            {
                headerName: "Address 1",
                field: "address_1",
                width: 120
            },
            {
                headerName: "Address 2",
                field: "address_2",
                width: 120
            },
            {
                headerName: "Area",
                field: "village",
                width: 120
            }
        ];
        this.addarea.columnDefs = [
            {
                headerName: "Village",
                field: "village"
            },
            {
                headerName: "Province",
                field: "province"
            }
        ];
        this.viewarea.columnDefs = [
            {
                headerName: "Village",
                field: "village"
            },
            {
                headerName: "Province",
                field: "province"
            }
        ];
        this.filterarea.columnDefs = [
            {
                headerName: "Village",
                field: "village"
            },
            {
                headerName: "Province",
                field: "province"
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>

<style lang="css">
.wr_input {
    border-radius: 12px;
}
</style>